var app = angular.module("leonardo");

var TaskAssignVendorsDialog = function($scope, $rootScope, TemplateService, PortfolioService, PropertyService, VendorService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.template = $scope.ngDialogData.template;
  $scope.vendorService = VendorService;
  $scope.vendorsIds = [];
  $scope.vendor_ids = [];

  $scope.portfolio = '';
  if ($scope.template && $scope.template.portfolio) {
    $scope.portfolio = $scope.template.portfolio;
  }
  else {
    $scope.portfolio = $scope.ngDialogData.portfolio ? $scope.ngDialogData.portfolio : '';
  }

  $scope.property = '';
  if ($scope.template && $scope.template.property) {
    $scope.property = $scope.template.property;
  }
  else {
    $scope.property = $scope.ngDialogData.property ? $scope.ngDialogData.property : '';
  }

  $scope.templateService = TemplateService;

  $scope.portfolios = [];
  $scope.properties = [];

  $scope.getPortfolios = function() {
    if (angular.isArray($scope.portfolio)) {
      return $scope.portfolio;
    }
    else {
      if (!isNull($scope.portfolio)) {
        return angular.isString($scope.portfolio) ? $scope.portfolio.split(',') : [$scope.portfolio];
      }
      else {
        return [];
      }
    }
  };

  $scope.getProperties = function() {
    if (angular.isArray($scope.property)) {
      return $scope.property;
    }
    else {
      if (!isNull($scope.property)) {
        return angular.isString($scope.property) ? $scope.property.split(',') : [$scope.property];
      }
      else {
        return [];
      }
    }
  };

  $scope.portfolios = !isEmpty($scope.getPortfolios()) ?
    PortfolioService.getlist({disable_pagination:true, essential:true, id:$scope.getPortfolios()}) : null;
  $scope.properties = !isEmpty($scope.getProperties()) ?
    PropertyService.getlist({disable_pagination:true, essential:true, id:$scope.getProperties()}): null;

  $scope.setDefaultValues = function() {
    angular.forEach($scope.task.vendors, function(value){
      $scope.vendorsIds.push(value.id);
    });
  };

  $scope.submit = function() {
    if (!angular.isArray($scope.vendor_ids)){
      if ($scope.vendor_ids.length == 0) {
        $scope.vendor_ids = [];
      }
      else {
        $scope.vendor_ids = $scope.vendor_ids.split(',');
      }
    }
    var portfolios = !isNull($scope.properties_data) && !isEmpty($scope.properties_data.portfolios) ?
      $scope.properties_data.portfolios : [];
    var properties = !isNull($scope.properties_data) && !isEmpty($scope.properties_data.properties) ?
      $scope.properties_data.properties : [];
    $scope.task.assignVendors({
      vendors: $scope.vendor_ids,
      notify: $scope.vendor_notify,
      portfolios: portfolios,
      properties: properties,
      set_to_template: $scope.set_to_template
    }).then(function(task) {
      $scope.confirm(task);
    });
  };

  $scope.setDefaultValues();

};

app.controller('TaskAssignVendorsDialog', ['$scope', '$rootScope', 'TemplateService', 'PortfolioService',
  'PropertyService', 'VendorService', TaskAssignVendorsDialog]);
